import { CustomizableValidator } from '../../../../../../../../ui/gzForm/validators/customizable.validator';
import { translateFn } from '../../../../../../../../utils/translator.helper';
import { ValidationResult } from '../../../../../../../../ui/gzForm/formField/types/form-validator';

function isUnixAbsolutePath(value: string): boolean {
  if (!value[0] || value[0] !== '/') {
    return false;
  }

  const nullCharRegex = new RegExp('\0');
  return !nullCharRegex.test(value);
}

// path validators
export const pathValidators = () => [
  CustomizableValidator((value: string) => {
    if (isUnixAbsolutePath(value)) {
      return { valid: true };
    }

    return {
      valid: false,
      error: translateFn('Invalid path'),
    };
  }),
];

// validate duplicates
export function validateDuplicates(ruleItem: { path: string }, rulesInGrid: { path: string }[]): ValidationResult {
  const hasDuplicates = rulesInGrid.some((ruleInGrid: { path: string }) => ruleInGrid.path === ruleItem.path);

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}
